import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
margin-top: 24px;
padding: 15px 16px;
border-radius: 20px;
border: 1px solid #999;
background: #E6FCE6;

ul {
	padding-inline-start: 16px !important;
}
`;

const Title = styled.div`
	margin-bottom: 16px;

	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #006400;
	text-align: center;
`;

const Text = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #4F4F4F;
	text-align: left;
`;

const TermsConditions = ({ title, rule }) => {
	const { t } = useTranslation();

	return (
		<Box>
			<Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
			<Text dangerouslySetInnerHTML={{ __html: rule }} />
		</Box>
	);
};

export default TermsConditions;
